export const setRippleResult = (response) => {
    return function (dispatch) {
        dispatch({
            type: "FETCH_RIPPLE_RESULT",
            payload: response,
        });
    };
};